export default __webpack_public_path__ + "static/media/Tooltip.874472c7.svg";